import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  BlurWithLogin,
  Translation,
  Button,
  Link,
  Blurred,
} from '../../common';
import { getBalanceWithCurrency } from '../../../constants/payment';
import { ReactComponent as IconEye } from '../../../assets/img/allgemein/eye.svg';

import Hyphenate from '../../../utils/hyphenate';
import { getOneTimeToken } from '../../../utils/token';

const LOGIN_DESCRIPTION_KEY = 'LIABILITY_STATEMENT_CENSORED';
const TITLE_TRANSLATION_KEY = 'LIABILITY_STATEMENT';

const CLAIM_TABLE_POSITION_KEY = 'CLAIM_TABLE_POSITION';
const CLAIM_TABLE_AMOUNT_KEY = 'CLAIM_TABLE_AMOUNT';
const CLAIM_TOTAL_AMOUNT_KEY = 'CLAIM_TOTAL_AMOUNT';

export const demandTableView = ({ styles, items }) => (
  <div className={styles['demand-table__table-wrapper']}>
    <div className={styles['demand-table__table']}>
      <div
        className={classNames(
          styles['demand-table__table-row'],
          styles['demand-table__table-header']
        )}
      >
        <Translation className={styles['demand-table__table-cell']}>
          {CLAIM_TABLE_POSITION_KEY}
        </Translation>
        <Translation
          className={classNames(
            styles['demand-table__table-cell'],
            styles['demand-table__table-cell_amount']
          )}
        >
          {CLAIM_TABLE_AMOUNT_KEY}
        </Translation>
      </div>
      {items &&
        items.map(({ amount, currency, subject }, key) => (
          <div className={styles['demand-table__table-row']} key={key}>
            <Hyphenate>
              <div className={styles['demand-table__table-cell']}>
                {subject}
              </div>
            </Hyphenate>
            <div
              className={classNames(
                styles['demand-table__table-cell'],
                styles['demand-table__table-cell_amount']
              )}
            >
              {getBalanceWithCurrency(amount, currency)}
            </div>
          </div>
        ))}
    </div>
  </div>
);

const MOCK_SUBTITLE = 'mock subtitle';

const DemandTableDocuments = ({
  styles,
  title,
  subtitle,
  link,
  isMobileOnly,
  blur,
}) => {
  const onClick = () => {
    getOneTimeToken().then((token) => {
      if (token) {
        window.open(link(token), '_blank');
      }
    });
  };

  return (
    <div
      className={
        styles[
          `demand-table__document-wrapper${isMobileOnly ? '_mobile-only' : ''}`
        ]
      }
    >
      {title ? (
        <Translation className={styles['demand-table__document-title']}>
          {title}
        </Translation>
      ) : null}
      <Blurred blur={blur} className={styles['demand-table__document-blur']}>
        {subtitle ? (
          !blur ? (
            <Translation className={styles['demand-table__document-subtitle']}>
              {subtitle}
            </Translation>
          ) : (
            <div className={styles['demand-table__document-subtitle']}>
              {MOCK_SUBTITLE}
            </div>
          )
        ) : null}
        <Button
          id="page.home.component.demand-table.document-button"
          className={styles['demand-table__document-button']}
          onClick={blur ? '' : onClick}
        >
          <IconEye className={styles['demand-table__document-eye']} />
        </Button>
      </Blurred>
    </div>
  );
};

export const mockData = [
  {
    amount: 100,
    currency: 'EUR',
    subject: 'Mock Subject 1',
  },
  {
    amount: 200,
    currency: 'EUR',
    subject: 'Mock Subject 2',
  },
  {
    amount: 300,
    currency: 'EUR',
    subject: 'Mock Subject 3',
  },
  {
    amount: 400,
    currency: 'EUR',
    subject: 'Mock Subject 4',
  },
  {
    amount: 500,
    currency: 'EUR',
    subject: 'Mock Subject 5',
  },
  {
    amount: 600,
    currency: 'EUR',
    subject: 'Mock Subject 6',
  },
  {
    amount: 700,
    currency: 'EUR',
    subject: 'Mock Subject 7',
  },
  {
    amount: 800,
    currency: 'EUR',
    subject: 'Mock Subject 8',
  },
  {
    amount: 900,
    currency: 'EUR',
    subject: 'Mock Subject 9',
  },
  {
    amount: 1000,
    currency: 'EUR',
    subject: 'Mock Subject 10',
  },
];

const DemandTable = ({
  items,
  balance,
  currency,
  blur,
  styles,
  headPic,
  extended,
}) => {
  return (
    <>
      <div className={styles['demand-table__wrapper']}>
        <div className={styles['demand-table__content']}>
          <div className={styles['demand-table__head']}>
            <Translation className={styles['demand-table__head-header']}>
              {TITLE_TRANSLATION_KEY}
            </Translation>
            <img
              className={styles['demand-table__head-pic']}
              src={headPic}
              alt="pen-pic"
            />
          </div>
          <div className={styles['demand-table__content-summary']}>
            <BlurWithLogin
              blur={blur}
              descriptionKey={LOGIN_DESCRIPTION_KEY}
              buttonClassName={styles['demand-table__blur-button']}
              mockData={demandTableView({
                styles,
                items: mockData,
              })}
              buttonId="page.home.component.demand-table.logout-button"
            >
              {(items && demandTableView({ styles, items })) || null}
            </BlurWithLogin>
            <div className={styles['demand-table__summary']}>
              <div className={styles['demand-table__summary-header']}>
                <Translation>{CLAIM_TOTAL_AMOUNT_KEY}</Translation>
                <span className={styles['demand-table__summary-value']}>
                  {balance != null
                    ? getBalanceWithCurrency(balance, currency)
                    : '(unbekannt)'}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles['demand-table__extended']}>
          {(extended &&
            extended.length &&
            extended.map(({ id, title, label, link, mobileOnly, blur }) => (
              <DemandTableDocuments
                {...{ styles, title, link, blur }}
                subtitle={label}
                isMobileOnly={mobileOnly}
                key={id}
              />
            ))) ||
            null}
        </div>
      </div>
    </>
  );
};

DemandTable.propTypes = {
  items: PropTypes.array,
  balance: PropTypes.number,
  currency: PropTypes.string,
  blur: PropTypes.bool,
  styles: PropTypes.object,
  headPic: PropTypes.string,
  extended: PropTypes.array,
};

export default DemandTable;
